import React, { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import Container from '@mui/material/Container';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import DialogActions from '@mui/material/DialogActions';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import PasswordIcon from '@mui/icons-material/Password';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import axios from 'axios'

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://material-ui.com/">
                Your Website
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}



const materialTheme = createTheme(({
    // set default for now
}));

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function ResetPassword(props) {
    const classes = useStyles();
    const [titleHeader, setTitleHeader] = useState('Enter your username to send an OTP code to your email.')
    const [showProgress, setShowProgress] = useState(false)
    const [openAlertDialog, setOpenAlertDialog] = useState(false)
    const [openAlertDialogOptVerification, setOpenAlertDialogOptVerification] = useState(false)
    const [hasErrorInSendingOtp, setHasErrorInSendingOtp] = useState(false)
    const [hasErrorInOtpVerification, setHasErrorInOtpVerification] = useState(false)
    const [openAlertDialogPasswordReset, setOpenAlertDialogPasswordReset] = useState(false)
    const [hasErrorInPasswordReset, setHasErrorInPasswordReset] = useState(false)
    const [errors, setErrors] = useState([])
    const [registrationErrorMessage, setErrorMessage] = useState('')
    const [progressDialogText, setProgressDialogText] = useState('Sending OTP... Please wait...')
    const [submitOtp, setSubmitOtp] = useState('SEND OTP')
    const [isSendtOtp, setIsSendOtp] = useState(true)
    const [isSubmitOtp, setIsSubmitOtp] = useState(false)
    const [isResetPass, setIsResetPass] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setConfirmShowPassword] = useState(false)
    const [userId, setUserId] = useState('')
    const [newUser, setNewUser] = useState({
        username: '',
    })
    const [newOtp, setOtpr] = useState({
        otp_verification: '',
    })
    const [newResetPassword, setNewResetPassword] = useState({
        new_password: '',
        re_password: '',
    })
    const usernameOnChange = (event) => {
        newUser.username = event.target.value
    }
    const otpOnChange = (event) => {
        newOtp.otp_verification = event.target.value
    }
    const resetNewPasswordOnChange = (event) => {
        newResetPassword.new_password = event.target.value
    }
    const resetReNewPasswordOnChange = (event) => {
        newResetPassword.re_password = event.target.value
    }

    function failedMessageView() {
        return (
            <>
                <List>
                    <ListItem>
                        {errors}
                    </ListItem>
                </List>
            </>
        )
    }


    function alertDialog() {
        return (
            <>
                <Dialog
                    open={openAlertDialog}
                    fullWidth={true}
                    maxWidth={'lg'}
                    onClose={() => { }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >

                    <DialogContent>

                        <Typography variant="h6" component="h2" style={{ color: (hasErrorInSendingOtp ? "red" : "green") }}>
                            {hasErrorInSendingOtp ? "Failed to send OTP. Please check error below." : "OTP sent to your email."}
                        </Typography>
                        {
                            failedMessageView()
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {

                                setOpenAlertDialog(false)
                                if (!hasErrorInSendingOtp) {
                                    props.isResetPassword(true)
                                }

                            }}
                            color="primary" autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }

    function failedMessageOtpVerificationView() {
        return (
            <>
                <List>
                    <ListItem>
                        {errors}
                    </ListItem>
                </List>
            </>
        )
    }


    function alertOtpVerificationDialog() {
        return (
            <>
                <Dialog
                    open={openAlertDialogOptVerification}
                    fullWidth={true}
                    maxWidth={'lg'}
                    onClose={() => { }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >

                    <DialogContent>

                        <Typography variant="h6" component="h2" style={{ color: (hasErrorInOtpVerification ? "red" : "green") }}>
                            {hasErrorInOtpVerification ? "Wrong OTP. Please check error below." : "OTP Verified Successfully."}
                        </Typography>
                        {
                            hasErrorInOtpVerification ? failedMessageOtpVerificationView() : ""
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {

                                setOpenAlertDialogOptVerification(false)
                                if (!hasErrorInOtpVerification) {
                                    props.isResetPassword(true)
                                }

                            }}
                            color="primary" autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }

    function failedMessagePasswordResetView() {
        return (
            <>
                <List>
                    <ListItem>
                        {errors}
                    </ListItem>
                </List>
            </>
        )
    }


    function alertPasswordResetDialog() {
        return (
            <>
                <Dialog
                    open={openAlertDialogPasswordReset}
                    fullWidth={true}
                    maxWidth={'lg'}
                    onClose={() => { }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >

                    <DialogContent>

                        <Typography variant="h6" component="h2" style={{ color: (hasErrorInPasswordReset ? "red" : "green") }}>
                            {hasErrorInPasswordReset ? "Please check error below." : "Reset Password Successfully."}
                        </Typography>
                        {
                            hasErrorInPasswordReset ? failedMessagePasswordResetView() : ""
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {

                                setOpenAlertDialogPasswordReset(false)
                                if (!hasErrorInPasswordReset) {
                                    props.isResetPassword(false)
                                } else {
                                    props.isResetPassword(true)
                                }

                            }}
                            color="primary" autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }
    function progressDialog() {
        return (
            <>
                <Dialog fullWidth={true} maxWidth={"sm"} open={showProgress}>
                    <DialogContent>
                        <DialogContentText>{progressDialogText}</DialogContentText>

                        <Box sx={{ width: "100%" }}>
                            <LinearProgress />
                        </Box>
                    </DialogContent>
                </Dialog>
            </>
        )
    }

    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
        formData.append(key, object[key]);
        return formData;
    }, new FormData());

    const onFormSubmit = (event) => {
        event.preventDefault();
        if (isSendtOtp) {
            createNewUser()
        }

        if (isSubmitOtp) {
            otpVerification()
        }

        if (isResetPass) {
            resetNewPassword()
        }

    }

    function createNewUser() {
        setShowProgress(true)

        const options = {
            credentials: false,
            method: 'POST',
            url: '/ResetPassword/sendOtp',
            data: objectToFormData(newUser)
        }
        axios(options)
            .then(res => {
                setShowProgress(false)

                const response = res.data;
                const error = response.errors;
                const isSucess = response.is_success;
                const message = response.message;
                const has_id = response.hasOwnProperty('id');

                if (has_id) {
                    setTitleHeader('Enter your OTP code.')
                    setSubmitOtp('SUBMIT OTP')
                    setIsSubmitOtp(true)
                    setIsSendOtp(false)
                    setUserId(response.id)
                }
                if (isSucess) {
                    setHasErrorInSendingOtp(false)
                    setErrors(error)

                } else {
                    setErrors(error)
                    setErrorMessage(message)
                    setHasErrorInSendingOtp(true)
                }
                setOpenAlertDialog(true)

            }).catch(error => {

                if (typeof error.response == 'undefined') {
                    // network error
                    setErrors([`Please checkout your internet connection.`])
                } else {
                    setErrors([`Failed to register. Code ${error.status}`])
                }
                setShowProgress(false)
                setHasErrorInSendingOtp(true)
                setOpenAlertDialog(true)
            })

    }

    function otpVerification() {
        setProgressDialogText('Verifying OTP... Please wait...')
        setShowProgress(true)
        const newUserOtpCopy = { ...newOtp }
        newUserOtpCopy.id = userId

        const options = {
            credentials: false,
            method: 'POST',
            url: '/ResetPassword/validateOtp',
            data: objectToFormData(newUserOtpCopy)
        }
        axios(options)
            .then(res => {
                setShowProgress(false)

                const response = res.data;
                const error = response.errors;
                const isSucess = response.is_success;
                const message = response.message;
                const user_id = response.hasOwnProperty('user_id');
                const reset_password = response.reset_password;

                if (user_id && reset_password) {
                    setUserId(response.user_id)
                    setSubmitOtp('RESET PASSWORD')
                    setIsSubmitOtp(false)
                    setIsSendOtp(false)
                    setIsResetPass(true)
                }
                if (isSucess) {
                    setHasErrorInOtpVerification(false)
                    setErrorMessage(message)

                } else {
                    setErrors(error)
                    setErrorMessage(message)
                    setHasErrorInOtpVerification(true)
                }
                setOpenAlertDialogOptVerification(true)

            }).catch(error => {

                if (typeof error.response == 'undefined') {
                    // network error
                    setErrors([`Please checkout your internet connection.`])
                } else {
                    setErrors([`Failed to register. Code ${error.status}`])
                }
                setShowProgress(false)
                setHasErrorInOtpVerification(true)
                setOpenAlertDialogOptVerification(true)
            })
    }

    function resetNewPassword() {
        setProgressDialogText('Reseting Password... Please wait...')
        setShowProgress(true)
        const newUserResetPasswordCopy = { ...newResetPassword }
        newUserResetPasswordCopy.id = userId
        const options = {
            credentials: false,
            method: 'POST',
            url: '/ResetPassword/resetPassword',
            data: objectToFormData(newUserResetPasswordCopy)
        }
        axios(options)
            .then(res => {
                console.log(res)
                setShowProgress(false)

                const response = res.data;
                const error = response.errors;
                const isSucess = response.is_success;
                const message = response.message;
                const reset_password = response.reset_password;

                if (reset_password) {
                    setSubmitOtp('RESET PASSWORD')
                    setIsSubmitOtp(false)
                    setIsSendOtp(false)
                    setIsResetPass(true)
                }
                if (isSucess) {
                    setHasErrorInPasswordReset(false)
                    setErrorMessage(message)

                } else {
                    console.log('dapat true')
                    setErrors(error)
                    setErrorMessage(message)
                    setHasErrorInPasswordReset(true)
                }
                setOpenAlertDialogPasswordReset(true)
                console.log(hasErrorInPasswordReset)
            }).catch(error => {

                if (typeof error.response == 'undefined') {
                    // network error
                    setErrors([`Please checkout your internet connection.`])
                } else {
                    setErrors([`Failed to register. Code ${error.status}`])
                }
                setShowProgress(false)
                setHasErrorInPasswordReset(true)
                setOpenAlertDialogPasswordReset(true)
            })
    }

    useEffect(() => {
        console.log("openAlertDialog change")

        console.log(errors)

    }, [errors])

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <PasswordIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    OTP
                </Typography>

                <Typography>
                    {titleHeader}
                </Typography>
                <form className={classes.form} autoComplete="off" onSubmit={onFormSubmit}>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                            <Grid container spacing={2}>
                                {isSendtOtp && (
                                    <Grid item xs={12}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="username"
                                            label="Username"
                                            name="username"
                                            onChange={usernameOnChange}
                                        />
                                    </Grid>
                                )}

                                {isSubmitOtp && (
                                    <Grid item xs={12}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="otp_verification"
                                            label="OTP Verification"
                                            name="otp_verification"
                                            onChange={otpOnChange}
                                        />
                                    </Grid>
                                )}

                                {/* {isResetPass && (
                                    <Grid item xs={12}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="new_password"
                                            label="New Password"
                                            name="new_password"
                                            type="password"
                                            onChange={resetNewPasswordOnChange}
                                        />
                                    </Grid>

                                )}

                                {isResetPass && (
                                    <Grid item xs={12}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="re_password"
                                            label="Re-type Password"
                                            name="re_password"
                                            type="password"
                                            onChange={resetReNewPasswordOnChange}
                                        />
                                    </Grid>
                                )} */}

                                {isResetPass && (
                                    <Grid item xs={12}>
                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                                            <OutlinedInput
                                                id="new_password"
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={showPassword ? 'text' : 'password'}
                                                name="new_password"
                                                label="Password"
                                                autoComplete='on'
                                                onChange={resetNewPasswordOnChange}
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={() => { setShowPassword(!showPassword) }}
                                                            onMouseDown={() => { }}
                                                            edge="end"
                                                        >
                                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                        </FormControl>

                                    </Grid>

                                )}

                                {isResetPass && (
                                    <Grid item xs={12}>
                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
                                            <OutlinedInput
                                                id="re_password"
                                                type={showConfirmPassword ? 'text' : 'password'}
                                                name="new_password"
                                                label="Password"
                                                autoComplete='on'
                                                onChange={resetReNewPasswordOnChange}
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={() => { setConfirmShowPassword(!showConfirmPassword) }}
                                                            onMouseDown={() => { }}
                                                            edge="end"
                                                        >
                                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                        </FormControl>

                                    </Grid>

                                )}

                            </Grid>
                        </ThemeProvider>
                    </StyledEngineProvider>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        {submitOtp}
                    </Button>
                    <Grid container>
                        <Grid item>
                            {/* <Link href="#" variant="body2" style={{ color: "black" }} onClick={() => { props.isResetPassword(false) }}>
                                Already have an account? Sign in
                            </Link> */}
                        </Grid>
                    </Grid>
                </form>
            </div>
            <Box mt={5}>
                {/* <Copyright /> */}
            </Box>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                    {progressDialog()}
                    {alertDialog()}
                    {alertOtpVerificationDialog()}
                    {alertPasswordResetDialog()}
                </ThemeProvider>
            </StyledEngineProvider>
        </Container>
    );
}